<div
  #scrollContainer
  (scroll)="onScroll($event)"
  class="infinite-scroll-container">

  @if (data?.length > 0) {
    @for (item of data; track $index) {
      <ng-container
        *ngTemplateOutlet="itemTemplate; context: { $implicit: item, index: $index }">
      </ng-container>
    }
    @if (isScrollDataLoading) {
      <ng-content select="[scrollLoader]"></ng-content>
    }
  } @else {
    <ng-content select="[noData]"></ng-content>
  }

</div>


